export default "__VITE_ASSET__mXeALhf___"